export default (t1: number, t2: number) => {
  let offset = 0;
  if (t1 > t2) {
    offset = -(t1 - t2);
  } else if (t2 > t1) {
    offset = t2 - t1;
  }
  return offset;
};
